// ProjectDashboardItemAdd Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'

class ProjectDashboardItemAdd extends Component {
  static get propTypes () {
    return {
      comment: PropTypes.string,
      onChange: PropTypes.func,
      onDelete: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      comment: null,
      onChange: null,
      onDelete: null
    }
  }

  render () {
    const { comment, onChange } = this.props

    return (
      <div className='project-dashboarditemadd'>
        <div className='itemleft'>
          <div className='status' />
          <div className='timestamp'>
            <IntlMessage ident='project.view.today' />
          </div>
        </div>
        <div className='itemright'>
          <div className='hovercontent'>
            <IconButton
              type='primary'
              icon='header-upload-delete'
              canHover
              title='project.list.tipView'
              className='act-avatar-delete'
              onClick={this._onClickDelete.bind(this)}
            />
          </div>
          <div className='itemmain'>
            <WysiwygEditor
              placeholder='project.view.yourComment'
              autoFocus
              value={comment}
              onBlur={onChange}
            />
          </div>
        </div>
      </div>
    )
  }

  /* Private function */
  _onClickDelete (e) {
    e.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(e)
    }
  }
}

export default ProjectDashboardItemAdd
